export default {
  eventsLoading: false,
  lastUpdate: 0,
  events: [],
  tickets: [],
  /** A map of charity IDs to their store data. */
  stores: {},
  /** A map of the client user's auth token for each store. */
  clientTokens: {},
};
